import React from "react";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Badge, { badgeClasses } from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useLocation, useNavigate } from 'react-router-dom';

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: -6px;
  }
`;

export default function IconButtonWithBadge({ count }) {
  const navigate = useNavigate();
  const location = useLocation();
  let productPageStyles = { position: "fixed", bottom: "60px", right: "60px", zIndex: "1000" };
  if (location.pathname.includes("SelectAProduct")) {
    productPageStyles = { position: "fixed", top: "75px", right: "210px", zIndex: "1000" };
  }
  return (
    <div className="d-flex justify-content-end" style={productPageStyles} onClick={() => navigate('/Cart')}>
      <IconButton aria-label={`view cart with ${count} items`} className="rounded-circle" style={{ width: "56px", height: "56px", borderRadius: "50%", border: "2px solid #DCE5E9", backgroundColor: "#b93636", color: "white" }}>
        <ShoppingCartIcon fontSize="large" />
        <CartBadge badgeContent={count} color="primary" overlap="circular" />
      </IconButton>
    </div>
  );
}
